module.exports = __webpack_public_path__ + "img/line.642fdb65.svg";